import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-gradient-bg',
    templateUrl: './block-gradient-bg.html',
    standalone: false,
})
export class BlockGradientBackground extends BlockAbstractComponent implements OnInit {}
